module.exports = __webpack_public_path__ + "r-v3/img/zoom_ori.5bdd7ba3.svg";